import { useReduxState } from 'hooks';
import { useFormState } from 'informed';
import {
  Checkbox,
  Emails,
  FormGroup,
  FormSection,
  Select
} from 'components/common/form';

interface FormValues {
  summaryEmailEnabled: boolean;
  summaryEmailFrequency: string;
  summaryEmailOptions: { [key: string]: boolean };
  summaryEmailRecipients: string[];
}

const PathSettingsSummaryEmail = () => {
  const { messages } = useReduxState();

  const formState = useFormState<FormValues>();

  const options = [
    {
      label: messages.pathsCompletions,
      value: 'pathCompletions',
      id: 'pathCompletions'
    },
    {
      label: messages.pathsExcelFileWithParticipantsData,
      value: 'participantsExcel',
      id: 'participantsExcel'
    }
  ];

  return (
    <FormSection
      maxWidth="100%"
      title={messages.settingsSummaryEmail}
      helpText={messages.pathsSummaryEmailHelpText}
    >
      <div>
        <Checkbox
          field="summaryEmailEnabled"
          id="summaryEmailEnabled"
          label={messages.settingsSummaryEmailSubscribe}
          style={{ marginTop: 5 }}
        />

        <FormGroup label={messages.commonRecipients}>
          <Emails
            disabled={!formState.values.summaryEmailEnabled}
            field="summaryEmailRecipients"
            id="summaryEmailRecipients"
          />
        </FormGroup>

        <FormGroup label={messages.pathsSummaryEmailContentsChoose}>
          {options.map((option) => (
            <Checkbox
              disabled={
                !formState.values.summaryEmailEnabled ||
                !formState.values.summaryEmailRecipients?.length
              }
              field={`summaryEmailOptions.${option.value}`}
              id={`summaryEmailOptions.${option.value}`}
              key={option.label}
              label={option.label}
              style={{ marginBottom: 5 }}
            />
          ))}
        </FormGroup>

        <FormGroup label={messages.settingsSummaryEmailFrequency}>
          <Select
            disabled={
              !formState.values.summaryEmailEnabled ||
              !formState.values.summaryEmailRecipients?.length
            }
            field="summaryEmailFrequency"
            id="summaryEmailFrequency"
            label="Frequency"
            options={[
              {
                label: messages.settingsSummaryEmailFrequencyDay,
                value: 'day'
              },
              {
                label: messages.settingsSummaryEmailFrequencyWeek,
                value: 'week'
              },
              {
                label: messages.settingsSummaryEmailFrequencyMonth,
                value: 'month'
              }
            ]}
            style={{ maxWidth: 200 }}
          />
        </FormGroup>
      </div>
    </FormSection>
  );
};

export default PathSettingsSummaryEmail;
